import React from 'react'
import { InboxOutlined } from '@ant-design/icons'
import { Modal, Input, Col, Row } from 'antd'
import { Timeline } from 'antd'
import styled from 'styled-components'
import moment from 'moment'
const Container = styled.div``
const Card = styled.div``
const modalHistory = (props) => {
  const { visible, setVisible, data } = props
  return (
    <Modal
      title={<h2>View History</h2>}
      maskClosable={false}
      className="modalNoBtn modal-history"
      visible={visible}
      onCancel={() => setVisible(false)}
      destroyOnClose
      footer={false}
    >
      {data.length > 0 ? (
        <Container className="container">
          <Timeline>
            {data?.map((item) => (
              <Timeline.Item
                className="container-timeline-item"
                dot={<div className="dot-custom"></div>}
              >
                <Card className="card">
                  <Col>
                    <Row className="layout-name">
                      <div className="grid">
                        <p className="cutter-text-line-1">
                          {item.firstname} {item.lastname}
                        </p>
                      </div>
                      <p className="smallStatus" style={{ minWidth: 'fit-content' }}>
                        {moment(item.created_at).format('DD/MM/YYYY LT')}
                      </p>
                    </Row>
                    <div className="grid">
                      <p className="reason-text cutter-text-line-multi-2">
                        {item.reason ? `"${item.reason}"` : '(No Comment)'}
                      </p>
                    </div>
                  </Col>
                </Card>
              </Timeline.Item>
            ))}
          </Timeline>
        </Container>
      ) : (
        <div className="emytystate empty-state">
          <InboxOutlined className="inbox" />
          <h2>No Data</h2>
        </div>
      )}
    </Modal>
  )
}

export default modalHistory
